module.exports = __webpack_public_path__ + "img/36557-034.12f1fa47.jpg";